import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { useAuth } from "hooks/useProvideAuth";
import NotFound from "./components/NotFound";
import AuthRoute from "./authRoute";
import AdminWebUserRoute from "./adminWebUserRoute";
import PowerUserRoute from "./powerUserRoute";
import "../theme/variables.css";

const AppRoute = () => {
  const { isPowerUser, isAuthenticated, isAuthLoaded }: any = useAuth();

  return (
    <Routes>
      {AuthRoute()}

      {!isAuthenticated && <Route path="*" element={<Navigate to="/login" />} />}

      {isPowerUser ? PowerUserRoute() : AdminWebUserRoute()}

      {/* Enable this after auth is loaded, all available routes are confirmed */}
      {isAuthLoaded && <Route path="*" element={<NotFound />} />}
    </Routes>
  );
};
export default AppRoute;
